import AffirmationProgramEntitlementService from 'src/modules/affirmationProgramEntitlement/affirmationProgramEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'ENTITLEMENT_FORM';

const affirmationProgramEntitlementFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AffirmationProgramEntitlementService.find(
          id,
        );
      }

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.INIT_ERROR,
      });

      getHistory().push('/affirmation-program-entitlement');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementFormActions.CREATE_STARTED,
      });

      await AffirmationProgramEntitlementService.create(
        values,
      );

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n(
          'entities.affirmationProgramEntitlement.create.success',
        ),
      );

      getHistory().push('/affirmation-program-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type:
          affirmationProgramEntitlementFormActions.UPDATE_STARTED,
      });

      await AffirmationProgramEntitlementService.update(
        id,
        values,
      );

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n(
          'entities.affirmationProgramEntitlement.update.success',
        ),
      );

      getHistory().push('/affirmation-program-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type:
          affirmationProgramEntitlementFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default affirmationProgramEntitlementFormActions;
